import { Box, Drawer, Tab, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { TabList, TabContext, TabPanel } from '@mui/lab';
import { useOrganizationItem } from './hooks';
import { History } from 'components/History/';
import { General } from './General';

interface OrganizationItemProps {
  open: boolean;
  handleClose: () => void;
  itemId: string;
}

export const OrganizationItem = ({
  open,
  handleClose,
  itemId,
}: OrganizationItemProps) => {
  const {
    handleTriggerChangeTab,
    tabIndex,
    organization,
    organizationHistory,
    historyPage,
    setHistoryPage,
    fetchedLogo,
    handleCloseTrigger,
    historyTabIndex,
  } = useOrganizationItem({
    id: itemId,
    handleClose,
  });

  return (
    <Drawer
      ModalProps={{ onClose: handleCloseTrigger }}
      anchor='right'
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '600px',
          height: '100%',
          paddingX: 3,
          paddingY: 3,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
        }}
      >
        {organization?.data && (
          <>
            <Box
              sx={{
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between',
                width: '100%',
                padding: '0',
                pb: '1rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {fetchedLogo?.data ? (
                  <img
                    width={'36px'}
                    height={'36px'}
                    src={URL.createObjectURL(fetchedLogo.data)}
                  />
                ) : (
                  <ApartmentIcon
                    sx={{ width: '36px', height: '36px' }}
                    color='primary'
                  />
                )}
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', pl: '1rem' }}
                >
                  <Typography variant='body1'>
                    {organization.data.name}
                  </Typography>
                  <Typography
                    variant='body2'
                    sx={{ color: theme => theme.palette.semiBlack.main }}
                  >
                    Organization
                  </Typography>
                </Box>
              </Box>

              <Box
                onClick={handleCloseTrigger}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  ':hover': {
                    cursor: 'pointer',
                    bgcolor: theme => theme.palette.grey[50],
                    borderRadius: '6px',
                  },
                  height: '30px',
                  width: '30px',
                }}
              >
                <ClearIcon />
              </Box>
            </Box>
            <TabContext value={tabIndex}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <TabList onChange={handleTriggerChangeTab}>
                  <Tab label='GENERAL' value='1' />
                  <Tab label='HISTORY' value={historyTabIndex} />
                </TabList>
              </Box>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value='1'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                  }}
                >
                  <General organization={organization.data} />
                </Box>
              </TabPanel>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value={historyTabIndex}
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                  }}
                >
                  {organizationHistory && (
                    <History
                      page={historyPage}
                      changePage={setHistoryPage}
                      history={organizationHistory.history}
                      count={organizationHistory.count}
                    />
                  )}
                </Box>
              </TabPanel>
            </TabContext>
          </>
        )}
      </Box>
    </Drawer>
  );
};
